// Typelizer digest 088af445d95b78ae8f9eb9a964eb1744
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /c/:company_id/counterparties/:counterparty_id/statement */
  show: (
    params: { counterpartyId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/counterparties/:counterparty_id/statement', params, options),
    method: 'get',
  }),
}
